import React, { useEffect, useState } from 'react';
import '../styles/Mekanisme.css';
import Mekanisme1 from '../assets/Mekanisme-1.png';
import Mekanisme2 from '../assets/Mekanisme-2.png';
import Mekanisme3 from '../assets/Mekanisme-3.png';
import Mekanisme4 from '../assets/Mekanisme-4.png';

const Mekanisme = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        const section = document.getElementById('mekanisme');
        if (section) observer.observe(section);

        return () => {
            if (section) observer.unobserve(section);
        };
    }, []);

    return (
        <section
            id="mekanisme"
            className={`mekanisme-pelayanan ${isVisible ? 'fadeIn' : ''}`}
        >
            <h2>Mekanisme Pelayanan</h2>
            <div className="mekanisme-grid">
                <div className="mekanisme-item">
                    <img src={Mekanisme1} alt="Mekanisme 1" />
                    <p>Penyintas mengisi form di website SAGARA.</p>
                </div>
                <div className="mekanisme-item">
                    <img src={Mekanisme2} alt="Mekanisme 2" />
                    <p>Tim akan memberikan pendampingan awal, lalu menghubungkan ke lembaga layanan KSP.</p>
                </div>
                <div className="mekanisme-item">
                    <img src={Mekanisme3} alt="Mekanisme 3" />
                    <p>Penyintas memilih bentuk pendampingan yang diinginkan, dan Tim akan membantu dalam proses tersebut.</p>
                </div>
                <div className="mekanisme-item">
                    <img src={Mekanisme4} alt="Mekanisme 4" />
                    <p>Tim menindaklanjuti laporan sesuai persetujuan penyintas.</p>
                </div>
            </div>
        </section>
    );
};

export default Mekanisme;
